import { render, staticRenderFns } from "./Speakers.vue?vue&type=template&id=4ae10de0&scoped=true&"
import script from "./Speakers.vue?vue&type=script&lang=js&"
export * from "./Speakers.vue?vue&type=script&lang=js&"
import style0 from "./Speakers.vue?vue&type=style&index=0&id=4ae10de0&lang=scss&scoped=true&"
import style1 from "./Speakers.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae10de0",
  null
  
)

export default component.exports